import { Component, Input } from '@angular/core'
import { CommonModule } from '@angular/common'

export type DateFormat =
  | 'd MMMM yyyy'
  | 'dd/MM/yy'
  | 'dd/MM/yyyy'
  | 'dd/MM/yy HH:mm'
  | 'dd/MM/yyyy HH:mm'

@Component({
    selector: 'case-date-yield',
    template: ` {{ date | date : (format ? format : 'dd/MM/yy') }} `,
    styleUrls: ['./date-yield.component.scss'],
    standalone: true,
    imports: [CommonModule]
})
export class DateYieldComponent {
  @Input() date: Date
  @Input() format: DateFormat
}
